<template>
	<div>
		<popup-detail 
			:id_ref="data.id"
    	direction="bottom" 
    	:show="show_detail"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="!getMerchant().is_preview_only"
    	@close="closePopUp">
    	<template v-slot:body>
    		<div v-if="data.id" class="py-3 px-3">
          <!-- IMAGE    -->
    			<div class="w-100 position-relative mb-3">
    				<flickity ref="flickity"
    					v-if="data.image_list.length > 0"
              :options="$fullSliderOption">
              <div class="carousel-cell w-100" 
                v-for="img in data.image_list">
                <div style="height:270px;" class="w-100">
                  <img
                  	:alt="data.name" 
                  	:src="img.image_url"
                    class="img-fit radius-12"
                    :class="{'grayscale' : !data.openTime.available}">
                </div>
              </div>
            </flickity>
    				<div style="height:270px;" v-else>
		        	<img :alt="data.name" :src="data.image_url" class="img-fit radius-12" :class="{'grayscale' : !data.openTime.available}"/>
		        </div>

		        <div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:10px;top:10px;" @click="closePopUp()">
							<img alt="close-icon" src="../../assets/img/icon/close.png" width="14" />
						</div>
						<span v-if="data.category != null" class="bg-white py-1 px-2 radius-12 body-3-1 position-absolute" style="left:10px;bottom:10px;">{{data.category.name}}</span>
            <!-- DELIVERY -->
            <template v-if="isDelivery && data.openTime.available">
              <p :id="`delivery-detail-${data.id}`" class="bg-white py-1 px-2 rounded body-3-1 position-absolute mb-0" style="right: 10px;bottom: 10px;">
                <img src="../../assets/img/icon/fast-delivery.png" width="24">
              </p>
              <b-tooltip :target="`delivery-detail-${data.id}`" placement="top" title="Available for delivery">
              </b-tooltip>
            </template>
    			</div>

          <!-- NAME & PRICE -->
	        <p class="mb-0 body-1-2">{{data.name}}</p>
	        <div class="w-100 no-ws mb-3">
	        	<p 
							v-if="is_variant"
							:class="is_decrease_promo?'w-100' : 'd-inline-block align-middle mr-2'" 
							class="body-3 mb-0" >
							Starting from
						</p>

						<p 
							v-if="is_decrease_promo" 
							class="mb-0 text-line-through body-3 d-inline-block align-middle mr-1">
							{{$formatCurrency(promotion_price)}}
						</p>
						<p 
							class="mb-0 body-1-4 text-green d-inline-block align-middle"
							:class="{
								'd-inline-block align-middle': is_decrease_promo
							}"
							>
							{{$formatCurrency(final_price)}}
						</p>
						<span v-if="is_decrease_promo" class="mb-0 font-bold text-green bg-green-light px-1 rounded-4 d-inline-block align-middle text-12 ml-2">-{{Math.floor(base_price.promotion_pct)}}%</span>
					</div>

          <!-- OPENING HOUR -->
          <div v-if="!data.openTime.available" class="w-100 p-2-5 rounded-4 mb-3 d-flex align-items-start" style="border-left: 3px solid #17a2b8; background-color: rgba(23, 162, 184, 0.05);">
            <div class="flex-shrink-0 mr-3">
              <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M4.60701 10.4562C4.23622 10.4562 3.95813 10.1781 3.95813 9.80724C3.95813 9.44575 4.23622 9.16763 4.60701 9.16763H8.80614V3.55954C8.80614 3.19802 9.08425 2.91994 9.44574 2.91994C9.80724 2.91994 10.0946 3.19802 10.0946 3.55954V9.80724C10.0946 10.1781 9.80724 10.4562 9.44574 10.4562H4.60701ZM9.455 18.91C14.6275 18.91 18.91 14.6182 18.91 9.455C18.91 4.28257 14.6182 0 9.44574 0C4.28257 0 0 4.28257 0 9.455C0 14.6182 4.29184 18.91 9.455 18.91Z" fill="#17A2B8"/>
              </svg>
            </div>
            <div class="w-100 pt-1">
              <p class="body-2-4 mb-1">Available hour</p>
              <p class="body-3-1 mb-0" v-html="data.openTime.message"></p>
            </div>
          </div>

          <!-- DESCRIPTION -->
	        <div v-if="!(data.description == null || data.description == '')" class="html-desc body-2-2-1 mb-3" v-html="data.description">
					</div>

          <!-- VARIANT -->
          <template v-if="is_variant && getMerchant().is_preview_only">
            <hr class="my-3" />
            <p class="body-3-1 mb-2">Variant List</p>
            <template v-for="(variant,index) in data.variant_list">
              <menuItemVariant 
                @updateQty="updateVariantQty"
                :data="variant" 
                :product_cart_index="product_cart_index"></menuItemVariant>
            </template>
          </template>
    		</div>
    	</template>
    	<template v-if="data.id && !getMerchant().is_preview_only && data.openTime.available" v-slot:footer>
    		<div v-if="data.id">
		    	<div class="px-3 pt-3" v-if="qtyCart == 0 && !is_variant">
			    	<button
			    	 	@click="changeQtyProduct('plus')" 
							class="ga-btn-primary-lg" >
							Select Product
						</button>
					</div>
					<template v-else>
						<div class="px-3 pt-3" v-if="is_variant">
				    	<button
				    	 	@click="toggleVariant(false)" 
								class="ga-btn-primary-lg" >
								 <span v-if="qtyCart == 0">Select Product</span>
								 <span v-else>{{qtyCart}} Variant Selected</span>
							</button>
						</div>
						<div class="row pt-2" v-else>
							<div class="col-12 text-center">
								<p class="body-3-1 mb-1">Selected Product</p>
							</div>
							<div class="col-4 offset-4 border-green py-2 radius-6">
								<div class="row no-gutters">
									<div class="col-4 align-self-center text-left">
										<div class="cursor-pointer" @click="changeQtyProduct('minus')">
											<img alt="minus-icon" src="../../assets/img/icon/decrement.png" class="d-inline-block img-crement rounded-100" width="28"
			              style="border:1px solid #70707046;">
										</div>
									</div>
									<div class="col-4 align-self-center text-center">
										<p class="mb-0 sub-heading-1-2 text-center">{{qtyCart}}</p>
									</div>
									<div class="col-4 align-self-center text-right">
										<div class="cursor-pointer" @click="changeQtyProduct('plus')">
											<img alt="plus-icon" src="../../assets/img/icon/increment.png" class="d-inline-block border-green img-crement rounded-100" width="28">
										</div>
									</div>
								</div>
							</div>
						</div>
					</template>
				</div>
	    </template>
    </popup-detail>

    <!-- VARIANTS -->
    <popup-detail 
			:id_ref="`${data.id}_variant`"
    	direction="bottom" 
    	:show="show_variant"
    	:use_max_size="true"
    	wrapper_size="mobile"
    	:use_footer="true"
    	@close="toggleVariant(true),toggleOpenVariant(false)">

    	<template v-slot:body>
    		<div class="w-100 border-bottom p-3 position-relative">
    			<div class="d-inline-block align-middle mr-2" style="width: 45px;height:42px;">
						<img :alt="data.name" :src="data.image_url" class="img-fit radius-6">
					</div>
					<div class="d-inline-block align-middle w-75">
						<p class="mb-0 body-1-2">{{data.name}}</p>
						<p class="mb-0 body-2" v-if="data.category != null">{{data.category.name}}</p>
					</div>
					<div class="bg-white rounded-circle position-absolute border-semi-grey" style="display:inline-flex;padding:10px; right:17px;top:21px;" @click="toggleVariant(true),toggleOpenVariant(false)">
						<img alt="close-icon" src="../../assets/img/icon/close.png" width="14" />
					</div>
    		</div>
    		<div class="p-3" :key="variant_detail_key">
    			<p class="body-3-1 mb-2">Variant List</p>
    			<template v-for="(variant,index) in data.variant_list">
    				<menuItemVariant 
    					@updateQty="updateVariantQty"
    					:data="variant" 
    					:product_cart_index="product_cart_index"></menuItemVariant>
    			</template>
    		</div>
    	</template>
    	<template v-slot:footer>
	    	<div class="px-3 pt-3">
		    	<state-button
		    	 	:click="saveVariantChange" 
						size="lg"
						variant="primary"
						block >
						Save Change
					</state-button>
				</div>
			</template>
    </popup-detail>
    <!-- END VARIANT -->
	</div>
</template>
<script>
	import {calculateFinalPriceConcierge} from '@/utils/index.js'
	import {mapGetters,mapMutations} from 'vuex';
	import menuItemVariant from '@/components/restaurant-v2/menuItemVariant'
	export default{
		props: ['data','show'],
		components:{
			menuItemVariant
		},
		data(){
			return{
				show_detail: false,
				show_variant: false,
				variant_detail_key: 0,
				open_variant: false,
				variant_update: []
			}
		},
		computed:{
			is_variant(){
				if(this.data.id){
        	return this.data.variant_list.length == 0 ? false : true
				}else{
					return false
				}
      },
      isDelivery(){
        if(!this.getMerchant().use_delivery) return false;
        if(!this.is_variant) return this.$isProductAllowDelivery(this.data);
        const isVariantHasDelivery = this.data.variant_list.some(variant => this.$isProductAllowDelivery(variant));
        return isVariantHasDelivery;
      },
      base_price(){
        if(this.data.id){
        	return this.is_variant ? this.data.variant_list[0].price : this.data.price
        }else{
        	return false
        }
      },
      final_price(){
      	if(this.data.id){
        	return calculateFinalPriceConcierge(this.base_price)
        }else{
        	return 0
        }
      },
      promotion_price(){
        if(!this.data.id || this.base_price.promotion_amount == 0){
          return 0
        }else{
          return this.base_price.tax_service_calculation_type == 'INCLUDE' ? (this.base_price.price_sell_base) : this.base_price.price_sell
        }
      },
      is_decrease_promo(){
        if(!this.data.id || this.base_price.promotion_amount == 0){
          return false
        }else{
          return this.base_price.promotion_type == 'INCREASE' ? false : true
        }
      },
      product_cart_index(){
      	return this.getRestaurantOrder().cart.findIndex(x=>x.product.data.product_id == this.data.product_id)
      },
      qtyCart(){
        let data = 0
        if(this.product_cart_index != -1){
          data = this.getRestaurantOrder().cart[this.product_cart_index].qty
        }

        return data
      },
		},
		watch:{
			show(){
				this.show_detail = this.show
			}
		},
		mounted(){
			this.show_detail = this.show
		},
		methods:{
			...mapGetters(['getMerchant','getRestaurantOrder']),
      ...mapMutations(['setRestaurantOrder','removeRestaurantOrder']),
      formatCurrency(value){
        return formatCurrency(value);
      },
      toggleDetail(){
        this.show_detail = !this.show_detail
      },
      closePopUp(){
        this.$emit('close', null)
      },
      changeQtyProduct(type){
        if(type == 'plus' && this.is_variant){
          this.toggleDetail()
        }else{
          let params = {
            product: this.data,
            variant: {},
            qty: this.qtyCart
          }
          if(this.qtyCart == 1 && type == 'minus'){
            this.removeRestaurantOrder(params)
          }else{
            if(type == 'minus'){
              params.qty--
            }else{
              params.qty++
            }
            this.setRestaurantOrder(params)
          }
        }
      },
      toggleOpenVariant(action){
      	this.open_variant = action
      },
      toggleVariant(action){
      	if (action == true) {
      		this.show_variant = false
      		this.variant_update = []
      	}else{
      		this.show_variant = true
      		if(this.product_cart_index != -1){
      			let variant_cart = this.getRestaurantOrder().cart[this.product_cart_index].variant
						this.variant_update = variant_cart.map(el=>{
							delete el.notes
							return el
						})
      		}
      	}
      	if (!this.open_variant) {
      		this.show_detail = action
      	}
      },
      updateVariantQty(variant){
      	let variant_i = this.variant_update.findIndex(x=>x.data.product_ga_pos_id == variant.data.product_ga_pos_id)
      	if(variant_i != -1){
      		if(variant.qty <= 0){
      			this.variant_update.splice(variant_i,1)
      		}else{
      			this.variant_update.splice(variant_i,1,variant)
      		}
      	}else{
      		this.variant_update.push(variant)
      	}
      },
      saveVariantChange(){
      	return new Promise((success,fail)=>{
      		if(this.product_cart_index == -1 && this.variant_update.length == 0){
      			console.log("none")
      			this.toggleVariant(true)
      			success()
      		}else{
      			let params = this.product_cart_index != -1 ? this.variant_update.length == 0 ? 'delete' : 'push_delete' : 'push'
      			this.updateVariantToVuex(params).then(()=>{
      				console.log("done")
      				this.toggleVariant(true)
      				success()
      			})
      		}
      	})
      },
      updateVariantToVuex(action){
      	return new Promise((success,fail)=>{
	    		if(action == 'push'){
	    			this.variant_update.forEach((item,index)=>{
		      		let params = {
		            product: this.data,
		            variant: item.data,
		            qty: item.qty
		          }
		          this.setRestaurantOrder(params)
		          if(index+1 == this.variant_update.length){
		          	console.log("push")
		          	success()
		          }
		      	})
	    		}else if(action == 'delete'){
	    			let variant_cart = this.getRestaurantOrder().cart[this.product_cart_index].variant
	    			variant_cart.forEach((item,index)=>{
	    				let params = {
		            product: this.data,
		            variant: item.data
		          }
		          this.removeRestaurantOrder(params)
		          if(this.product_cart_index == -1){
		          	console.log("delete")
		          	success()
		          }
	    			})
	    		}else{
	    			this.variant_update.forEach((item,index)=>{
		      		let params = {
		            product: this.data,
		            variant: item.data,
		            qty: item.qty
		          }
		          this.setRestaurantOrder(params)
		          if(index+1 == this.variant_update.length){
		          	let diff = this.getRestaurantOrder().cart[this.product_cart_index].variant.filter(x=> !this.variant_update.some(y=>x.data.id == y.data.id))
		          	diff.forEach((item_diff,index_diff)=>{
		          		let params = {
				            product: this.data,
				            variant: item_diff.data
				          }
				          this.removeRestaurantOrder(params)
				          if(index_diff+1 == diff.length){
				          	console.log("push_delete")
				          	success()
				          }
		          	})
		          	if(diff.length == 0){
		          		console.log("other")
		          		success()
		          	}
		          }
		      	})
	    		}
      	})
      }
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/restaurant-v2/menuDetail.vue